import { render, staticRenderFns } from "./TableRiskAppraisalEp_3x3.vue?vue&type=template&id=5ee7ac6f&scoped=true"
import script from "./TableRiskAppraisalEp_3x3.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisalEp_3x3.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisalEp_3x3.vue?vue&type=style&index=0&id=5ee7ac6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee7ac6f",
  null
  
)

export default component.exports